<template>
    <CLink
        class="lg-ibc"
    >
        <i class="fas fa-question-circle"></i>
    </CLink>
  
</template>

<script>
import { cilInfo } from '@coreui/icons';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; 
import '@fortawesome/fontawesome-free/js/brands.js';
import '@fortawesome/fontawesome-free/js/solid.js';
import '@fortawesome/fontawesome-free/js/fontawesome.js';
export default {
    name: "InfoBallonComponent",
    icons:{
        cilInfo
    },
    data(){
        return {

        }
    },
    props:{
        tooltipText:{
            default:"What is this?",
            type:String
        },
        tooltipLink:{
            default:null
        }
    },
    methods:{
        initCustomTooltip(){
            this.tooltip = tippy(this.$el, {
                content: `<a href=${this.tooltipLink} >${this.tooltipText}</a>`,
                allowHTML: true,
                placement: 'right',
                interactive: true,
            });  
        }
    },
    mounted(){
        this.initCustomTooltip();
    }
}
</script>

<style lang="scss">
    .lg-ibc{
        color: black;
        font-size: 0.9rem;
        & .tippy-content{
            color: white !important;
            text-decoration: none;
            
        }
    }
</style>